import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Classes } from '@blueprintjs/core';
import styled from 'styled-components';

const ButtonContainer = styled.div`
  text-align: right;
  margin-top: 20px;
`;

const DialogPanelBody = props => (
  <div
    className={classNames({
      [Classes.DIALOG_BODY]: true,
      [props.className]: props.className,
    })}
  >
    {props.children}

    {props.actionButton && <ButtonContainer>{props.actionButton}</ButtonContainer>}
  </div>
);

DialogPanelBody.propTypes = {
  actionButton: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default DialogPanelBody;
